export interface Environment {
  production: boolean;
  i18nHash: string;
  address: string;
  statistics: string;
  bugsProject: string;
  emailserver: string;
  modelautomation: string;
  autoscript: string;
  wcag: string;
  seo: string;
  ads: string;
  golive: string;
}

export const i18nHash = '6fba331c';
